<template>
  <div style="display: none;">
    <div id="printMe">
      <div
        v-for="product in productInfos"
        v-bind:key="product.id"
        class="printArea"
        style="width : 49mm; height: 39mm; max-height: 39mm; display: flex; align-items: center; justify-content: center;"
      >
        <div :style="style">
          <table
            style="
              display: contents;
              width: 49mm;
              height: 39mm;
            "
          >
            <tr>
              <td style="padding-top: 7px; padding-left: 6px; padding-bottom: 7px;">
                <qrcode-vue
                  :value="product.url"
                  level="H"
                  :renderAs="renderAs"
                  :size="QrCodeSize"
                ></qrcode-vue>
              </td>
            </tr>

            <tr>
              <td>
                <p style="margin: 0;">
                  <font
                    class="authCodeFont"
                    style="
                      font-size: 11px;
                      color: #fff;
                      display: block;
                      padding-left: 33px;
                    "
                    >{{ product.authCode }}</font
                  >
                </p>
              </td>
            </tr>
            <tr>
              <td>
                <p style="margin: 0px;">
                  <font
                    style="
                      font-size: 8px;
                      white-space: normal; 
                      text-align: left; 
                      word-wrap: break-word;
                      display: -webkit-box; 
                      -webkit-line-clamp: 3; 
                      -webkit-box-orient: vertical;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      padding-left: 6px;
                      padding-top: 5px;
                    "
                  >
                    {{ product.productName }} - {{ product.variant_name }}
                  </font>
                </p>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import M from "@/libs/mapping.js";
import Vue from "vue";
import QrcodeVue from "qrcode.vue";
import VueHtmlToPaper from "vue-html-to-paper";
import CommonMixin from "@/mixins/CommonMixin.js";
import store from "../../../../store";
import interpeople1_50_40 from "@/assets/authservice/custom_print_images/interpeople1_50_40.jpg";

const options = {
  name: "_blank",
  specs: ["fullscreen=yes", "titlebar=no", "scrollbars=yes"],
  styles: ["/style/CustomInterpeople1LabelType1.css"],
};

Vue.use(VueHtmlToPaper);

export default {
  data() {
    return {
      productInfos: [],
      QrCodeValue: "http://m." + store.state.mallId + ".cafe24.com",
      QrCodeSize: "70",
      renderAs: "svg",
      tableDatas: [],
      listCount: 0,
      style: `background-image: url("${interpeople1_50_40}"); background-size: 100%; background-repeat: no-repeat; width:48mm; height: 38mm;`,
    };
  },
  components: {
    QrcodeVue,
  },
  mixins: [CommonMixin],
  methods: {
    btnOnClick: function() {
      this.tableDatas.push({
        itemname: "item",
        quantity: 1,
        sellingprice: 55,
        amount: 55,
      });
    },
    qrPrint: async function() {
      await this.$htmlToPaper("printMe", options);
    },
    qrCodePringttingContents: async function(datas) {
      this.productInfos = [];
      for (let i = 0; i < datas.length; i++) {
        let encrySerialNumber = btoa(
          encodeURI(datas[i].serial_number)
        );
        let _url = "http://m." + store.state.mallId + ".cafe24.com/royalty.html";
        // 대표도메인 있으면 대표도메인으로
        if (sessionStorage.getItem(`${this.$store.state.mallId}_domain`)) {
          _url =
            "http://" +
            sessionStorage.getItem(`${this.$store.state.mallId}_domain`) +
            "/royalty.html";
        }
        const regex = /\(\+[^)]*\)/g;
        const result_variantName = datas[i].variant_name.replace(regex, '');
        let variant_name = result_variantName;
        if (variant_name.indexOf("+0") > -1) {
          variant_name = variant_name.replaceAll("+0", "");
        }
        let QrData = {
          id: this.listCount,
          url: _url + "?authQrCode=" + encrySerialNumber,
          authCode: datas[i].serial_number,
          productName: datas[i].product_name,
          variantName: datas[i].variant_name,
          variant_name,
        };
        this.productInfos.push(QrData);
        this.listCount++;
      }
    },
    setQrPrintList: async function(data) {
      let getCount = data.length;
      if (!getCount) {
        alert("선택된 상품이 없습니다.");
        return false;
      }
      await this.qrCodePringttingContents(data);

      if (this.listCount == 0) {
        alert("인쇄수량이 없습니다.");
        return false;
      }
      this.qrPrint();
    },
    /**
     * QR 코드 인쇄 설정 정보 가져오기
     */
    getQrcodeSettingInfo: async function() {},

    cutProductName: function(text) {
      return text.substr(0, 15);
    },
    async sleep(ms) {
      return new Promise((r) => setTimeout(r, ms));
    }
  },
  created: async function() {
    //같은 자식 컴포넌트로 부터 setList 을 emit 한 함수를 on 으로 받아 setProductList 메소드 호출
    this.eventHub.$on("setQrPrintList", this.setQrPrintList);
  },
};
</script>

<style>
.poppine-font {
  zoom: 0.7;
}
</style>
